import {
  Button,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { createWarehouseApi } from "../../../components/api/WarehouseApiService";
import { companies, recordStatus, status, units } from "../../../utils/menu-items";

const AddWarehouseInventory = (props) => {
  const navigate = useNavigate();
  const { setAddViewStates, addViewStates, rows, setRows, setAddView } = props;

  useEffect(
    () =>
      setAddViewStates({
        ...addViewStates,
        shippedAmountUnit: "KG",
        unshippedAmountUnit: "KG",
      }),
    [],
  );

  return (
    <>
      <Stack direcion="column">
        <Typography variant="body1" mb={2}>
          Create New Warehouse Inventory Record
        </Typography>
        <Grid container xs={12} spacing="8px">
        <Grid item xs={12} sm={2}>
            <Typography variant="body2">Name</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  name: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Select Item</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  itemId: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Shipped Amount</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              type="number"
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  shippedAmount: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Shipped Amount Unit</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              select
              defaultValue={"KG"}
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  shippedAmountUnit: e.target.value,
                })
              }
            >
              {units.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Unshipped Amount</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              type="number"
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  unshippedAmount: e.target.value,
                })
              }
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Unshipped Amount Unit</Typography>
            <TextField
              variant="outlined"
              size="small"
              fullWidth
              select
              defaultValue={"KG"}
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  unshippedAmountUnit: e.target.value,
                })
              }
            >
              {units.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Select Record Status</Typography>
            <TextField
              id="outlined-select-status"
              select
              variant="outlined"
              size="small"
              fullWidth
              label={"ACTIVE"}
              onChange={(e) =>
                setAddViewStates({
                  ...addViewStates,
                  recordStatus: e.target.value,
                })
              }
            >
              {recordStatus.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Stack direction="row" spacing={1} mt={1}>
          <Button variant="outlined" onClick={() => setAddView(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              const newId = Math.floor(Math.random() * 100000);
              setAddViewStates({ ...addViewStates, id: newId });
              setRows([addViewStates, ...rows]);
              setAddView(false);

              createWarehouseApi(addViewStates)
                .then((response) => {
                  window.location.reload();
                  navigate("/warehouse-view");
                })
                .catch((error) => {
                  console.log(error.response.data);
                });
            }}
          >
            Add
          </Button>
        </Stack>
      </Stack>
    </>
  );
};

export default AddWarehouseInventory;
